/** Build avatar initials from student name fields. */
export const getStudentInitials = (
  firstName?: string | null,
  lastName?: string | null
): string => {
  const first = firstName?.trim()?.charAt(0) ?? ""
  const last = lastName?.trim()?.charAt(0) ?? ""
  const initials = `${first}${last}`.toUpperCase()
  return initials || "S"
}
